export const info2Data = {
  sections: [
    {
      title: "Amenities",
      block: [
        {
          headline: "Berkeley",
          body: "When you buy a home from Berkeley you can be safe in the knowledge that it is built to very high standards of design and quality, has low environmental impact and that you will enjoy an exceptional customer experience.",
          img: {
            id: "671b6c8a6536c7a47560a0bb",
            publicURL: "/assets/imgs/Story/2.webp",
            filename: "gym.jpg",
            mimeType: "image/jpeg",
            filesize: 13674711,
            width: 7680,
            height: 4320,
            focalX: 50,
            focalY: 50,
            createdAt: "2024-10-25T10:01:46.787Z",
            updatedAt: "2024-10-25T10:01:46.787Z",
            url: "/assets/imgs/Story/1.webp",
            thumbnailURL: null,
          },
          id: "671b6be08844e00026fe98fe",
        },
        {
          headline: "TRANSFORMING tomorrow",
          body: "At Berkeley Group our passion and purpose is to build quality homes, strengthen communities and improve people’s lives. We are innovating, pushing boundaries and taking action to ensure we have a long-term, positive impact that is good for our customers, the communities we touch, our business and the world around us.",
          img: {
            id: "671a29688168a18eb3451bac",
            publicURL: "/assets/imgs/Story/8.webp",
            filename: "lounge.webp",
            mimeType: "image/webp",
            filesize: 324732,
            width: 2500,
            height: 1500,
            focalX: 50,
            focalY: 50,
            createdAt: "2024-10-24T11:03:04.669Z",
            updatedAt: "2024-10-24T11:03:04.669Z",
            url: "/assets/imgs/Story/2.webp",
            thumbnailURL: null,
          },
          id: "671b6d328844e00026fe996e",
        },
      ],
    },
    {
      title: "Amenities",
      block: [
        {
          headline: "OUR sustainability PROMISE",
          body: "Nature And Biodiversity Gardens, trees, flowers, hedges and water – these are the fundamentals of a natural environment that can be enjoyed by everyone. Our aim at Trillium is to deliver a biodiversity net gain of 224%. We will achieve this by creating natural habitats on the living roofs and green spaces at ground level, encouraging wildlife to flourish with rich and varied planting schemes.",
          img: {
            id: "671b6c8a6536c7a47560a0bb",
            publicURL: "/assets/imgs/Story/10.webp",
            filename: "gym.jpg",
            mimeType: "image/jpeg",
            filesize: 13674711,
            width: 7680,
            height: 4320,
            focalX: 50,
            focalY: 50,
            createdAt: "2024-10-25T10:01:46.787Z",
            updatedAt: "2024-10-25T10:01:46.787Z",
            url: "/assets/imgs/Story/8.webp",
            thumbnailURL: null,
          },
          id: "671b6be08844e00026fe98fe",
        },
        {
          headline: "Construction Process",
          body: "As part of Our Vision 2030, the Berkeley Group is aiming to reduce emissions from direct operations by 50% between 2019 and 2030, achieve a year-on-year reduction in water use during construction, and divert 95% of waste from landfill (98% from 2025). We use modern methods of construction to help reduce the environmental impact of building our homes, and all materials are responsibly sourced, including timber which is all FSC or PEFC certified.",
          img: {
            id: "671a29688168a18eb3451bac",
            publicURL: "/assets/imgs/Story/10.webp",
            filename: "lounge.webp",
            mimeType: "image/webp",
            filesize: 324732,
            width: 2500,
            height: 1500,
            focalX: 50,
            focalY: 50,
            createdAt: "2024-10-24T11:03:04.669Z",
            updatedAt: "2024-10-24T11:03:04.669Z",
            url: "/assets/imgs/Story/16.webp",
            thumbnailURL: null,
          },
          id: "671b6d328844e00026fe996e",
        },
        {
          headline: "Sustainable Transport",
          body: "Trillium will provide secure cycle spaces and 17 EV charging points. Along with safe pedestrian routes along green streets, Trillium has been designed to encourage the use of sustainable methods of transport, to help improve local air quality, reduce carbon emissions, and contribute to the health and well-being of residents.",
          img: {
            id: "671a29688168a18eb3451bac",
            publicURL: "/assets/imgs/Story/10.webp",
            filename: "lounge.webp",
            mimeType: "image/webp",
            filesize: 324732,
            width: 2500,
            height: 1500,
            focalX: 50,
            focalY: 50,
            createdAt: "2024-10-24T11:03:04.669Z",
            updatedAt: "2024-10-24T11:03:04.669Z",
            url: "/assets/imgs/Story/16.webp",
            thumbnailURL: null,
          },
          id: "671b6d328844e00026fe996e",
        },
        {
          headline: "Future-Proof Design",
          body: "From the early stages of design, we assess how our homes will stand up to the future effects of climate change, such as how they will be affected by higher summer temperatures, periods of drought, or more extreme rainfall. We are constantly researching how we can ensure our homes and developments are more resilient to these extremes to understand what new innovative technologies we should use in our future designs.",
          img: {
            id: "671a29688168a18eb3451bac",
            publicURL: "/assets/imgs/Story/10.webp",
            filename: "lounge.webp",
            mimeType: "image/webp",
            filesize: 324732,
            width: 2500,
            height: 1500,
            focalX: 50,
            focalY: 50,
            createdAt: "2024-10-24T11:03:04.669Z",
            updatedAt: "2024-10-24T11:03:04.669Z",
            url: "/assets/imgs/Story/16.webp",
            thumbnailURL: null,
          },
          id: "671b6d328844e00026fe996e",
        },
        {
          headline: "Noise Reduction",
          body: "We can’t eliminate noise, but we consider the impact of noise in the design of our homes. We consider external noise, such as from nearby roads, and internal noise including the transfer between rooms and floors. We incorporate measures to reduce the different types of noise wherever possible to create a quieter environment.",
          img: {
            id: "671a29688168a18eb3451bac",
            publicURL: "/assets/imgs/Story/10.webp",
            filename: "lounge.webp",
            mimeType: "image/webp",
            filesize: 324732,
            width: 2500,
            height: 1500,
            focalX: 50,
            focalY: 50,
            createdAt: "2024-10-24T11:03:04.669Z",
            updatedAt: "2024-10-24T11:03:04.669Z",
            url: "/assets/imgs/Story/16.webp",
            thumbnailURL: null,
          },
          id: "671b6d328844e00026fe996e",
        },
        {
          headline: "Low Carbon Homes",
          body: "The development will be gas free, with an electric only heating and hot water system, enhanced levels of thermal insulation and all homes will be fitted with a master light switch by the front door. Low energy LED lighting will be used throughout, and appliances will have high energy efficiency ratings. Smart meters will also be fitted to display energy consumption and help reduce usage.",
          img: {
            id: "671a29688168a18eb3451bac",
            publicURL: "/assets/imgs/Story/10.webp",
            filename: "lounge.webp",
            mimeType: "image/webp",
            filesize: 324732,
            width: 2500,
            height: 1500,
            focalX: 50,
            focalY: 50,
            createdAt: "2024-10-24T11:03:04.669Z",
            updatedAt: "2024-10-24T11:03:04.669Z",
            url: "/assets/imgs/Story/16.webp",
            thumbnailURL: null,
          },
          id: "671b6d328844e00026fe996e",
        },
        {
          headline: "Water Efficiency",
          body: "Our homes are designed to high water efficiency standards and are fitted with dual flush WCs, and low-flow taps and showerheads, which use less water without compromising convenience and comfort. This helps each home achieve a designed water use of 105 litres per person per day. Green roofs will help manage surface water runoff and rainwater harvesting will be used to help irrigate the gardens.",
          img: {
            id: "671a29688168a18eb3451bac",
            publicURL: "/assets/imgs/Story/10.webp",
            filename: "lounge.webp",
            mimeType: "image/webp",
            filesize: 324732,
            width: 2500,
            height: 1500,
            focalX: 50,
            focalY: 50,
            createdAt: "2024-10-24T11:03:04.669Z",
            updatedAt: "2024-10-24T11:03:04.669Z",
            url: "/assets/imgs/Story/16.webp",
            thumbnailURL: null,
          },
          id: "671b6d328844e00026fe996e",
        },
        {
          headline: "Waste And Recycling",
          body: "We actively encourage all residents to reduce their waste wherever possible. In addition to external recycling bins, we provide integrated space saving recycling bins to make it easier for residents to separate and recycle waste.",
          img: {
            id: "671a29688168a18eb3451bac",
            publicURL: "/assets/imgs/Story/10.webp",
            filename: "lounge.webp",
            mimeType: "image/webp",
            filesize: 324732,
            width: 2500,
            height: 1500,
            focalX: 50,
            focalY: 50,
            createdAt: "2024-10-24T11:03:04.669Z",
            updatedAt: "2024-10-24T11:03:04.669Z",
            url: "/assets/imgs/Story/16.webp",
            thumbnailURL: null,
          },
          id: "671b6d328844e00026fe996e",
        },
      ],
    },
    {
      title: "Amenities",
      block: [
        {
          headline: "TRILLIUM BALANCE BY DESIGN",
          body: "Rising elegantly beside Paddington Green, Trillium offers residents stunning views of the London skyline.",
          img: {
            id: "671a29688168a18eb3451bac",
            publicURL: "/assets/imgs/Story/21.webp",
            filename: "lounge.webp",
            mimeType: "image/webp",
            filesize: 324732,
            width: 2500,
            height: 1500,
            focalX: 50,
            focalY: 50,
            createdAt: "2024-10-24T11:03:04.669Z",
            updatedAt: "2024-10-24T11:03:04.669Z",
            url: "/assets/imgs/Story/16.webp",
            thumbnailURL: null,
          },
          id: "671b6d328844e00026fe996e",
        },
        {
          headline: "DISCOVER HOME",
          body: "Embrace a redefined lifestyle experience by Berkeley, where tranquil living effortlessly belongs in the vibrancy of the city.",
          img: {
            id: "671b6c8a6536c7a47560a0bb",
            publicURL: "/assets/imgs/Story/20.webp",
            filename: "gym.jpg",
            mimeType: "image/jpeg",
            filesize: 13674711,
            width: 7680,
            height: 4320,
            focalX: 50,
            focalY: 50,
            createdAt: "2024-10-25T10:01:46.787Z",
            updatedAt: "2024-10-25T10:01:46.787Z",
            url: "/assets/imgs/Story/8.webp",
            thumbnailURL: null,
          },
          id: "671b6be08844e00026fe98fe",
        },
        {
          headline: "YOUR urban RETREAT",
          body: "The development features Manhattans, 1-4 bedroom apartments, and penthouses, all enhanced by exceptional amenities, landscaped public spaces and thoughtfully designed outdoor areas.",
          img: {
            id: "671a29688168a18eb3451bac",
            publicURL: "/assets/imgs/Story/6.webp",
            filename: "lounge.webp",
            mimeType: "image/webp",
            filesize: 324732,
            width: 2500,
            height: 1500,
            focalX: 50,
            focalY: 50,
            createdAt: "2024-10-24T11:03:04.669Z",
            updatedAt: "2024-10-24T11:03:04.669Z",
            url: "/assets/imgs/Story/16.webp",
            thumbnailURL: null,
          },
          id: "671b6d328844e00026fe996e",
        },
        {
          headline: "ELEGANT natural SPACE",
          body: "The Mansion inspired Blocks draw inspiration from the architectural heritage of Maida Vale, featuring well-proportioned façades and high-quality materials, complemented by thoughtfully landscaped surroundings that blend historical context with contemporary living.",
          img: {
            id: "671a29688168a18eb3451bac",
            publicURL: "/assets/imgs/Story/7.webp",
            filename: "lounge.webp",
            mimeType: "image/webp",
            filesize: 324732,
            width: 2500,
            height: 1500,
            focalX: 50,
            focalY: 50,
            createdAt: "2024-10-24T11:03:04.669Z",
            updatedAt: "2024-10-24T11:03:04.669Z",
            url: "/assets/imgs/Story/16.webp",
            thumbnailURL: null,
          },
          id: "671b6d328844e00026fe996e",
        },
        {
          headline: "At ONE with NATURE",
          body: "From Trillium Square to Newcastle Place, each area is infused with art, water features and natural play elements, contributing to an engaging and restorative environment.",
          img: {
            id: "671a29688168a18eb3451bac",
            publicURL: "/assets/imgs/Story/10.webp",
            filename: "lounge.webp",
            mimeType: "image/webp",
            filesize: 324732,
            width: 2500,
            height: 1500,
            focalX: 50,
            focalY: 50,
            createdAt: "2024-10-24T11:03:04.669Z",
            updatedAt: "2024-10-24T11:03:04.669Z",
            url: "/assets/imgs/Story/16.webp",
            thumbnailURL: null,
          },
          id: "671b6d328844e00026fe996e",
        },
      ],
    },
  ],
}
